import React from "react";

interface AuthorChipProps {
  name: string;
}

/** Small rounded pill showing the authoring doctor's name on a note entry. */
export const AuthorChip: React.FC<AuthorChipProps> = ({ name }) => (
  <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium bg-sky-50 text-sky-700">
    {name || "Unknown doctor"}
  </span>
);
